import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {BrandingApiService} from '../../../../projects/api/src/branding/branding-api.service';
import {ConfigureService} from '../../../../projects/common/modules/configure/configure.service';
import {RouterOutlet} from '@angular/router';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-login-form-background',
  templateUrl: './login-form-background.component.html',
  standalone: true,
  imports: [
    RouterOutlet,
    NgIf
  ],
  styleUrls: ['./login-form-background.component.scss']
})
export class LoginFormBackgroundComponent implements OnInit {

  constructor(private brandingApi: BrandingApiService, private ref: ChangeDetectorRef, private configService: ConfigureService) {
    this.production = environment.production;
  }

  public loginBackgroundUrl = null;
  public production;

  ngOnInit() {
    console.log('production:' + this.production);
    this.setBackground();
  }

  setBackground() {
    let bgDiv: any;
    bgDiv = document.getElementsByClassName('c-login__bg-img_mcity')[0];
    if (this.configService.options.appConfig.mainBackgroundUrl) {
      this.loginBackgroundUrl = this.configService.options.appConfig.mainBackgroundUrl;
      bgDiv.style.backgroundImage = `url(${this.loginBackgroundUrl}`;
    } else {
      this.brandingApi.isExist('backgroundImage').subscribe(data => {
          bgDiv = document.getElementsByClassName('c-login__bg-img_mcity')[0];
          if (data) {
            this.loginBackgroundUrl = this.brandingApi.makeImageUrl('backgroundImage');
            bgDiv.style.backgroundImage = `url(${this.loginBackgroundUrl}`;
          } else {
            bgDiv.style.backgroundImage = `url(assets/static/img/content/bgimage.jpg)`;
          }
          this.ref.markForCheck();
        }, error => {
          console.log(error);
          bgDiv.style.backgroundImage = `url(assets/static/img/content/bgimage.jpg)`;
          this.ref.markForCheck();
        }
      );
    }
  }
}
